// extracted by mini-css-extract-plugin
export default {"releaseDateBanner":"_Pf4u","access-view":"SGlNU","access-purchase":"H_t8G"};